import React from "react";

const ErrorFallback = ({ error }) => {
  console.log(error);

  const redirectHandler = () => {
    window.location.reload();
  };

  return (
    <div
      className='fixed left-0 top-0 flex h-full w-full flex-col items-center justify-center gap-2 border-2'
      dir='ltr'
    >
      <h1 className='font-iranyekan text-[32px] font-[600] text-black opacity-30'>
        Oops, something went wrong :(
      </h1>
      <utton
        className='rounded-full bg-gray-500 text-white'
        onClick={redirectHandler}
      >
        Try again
      </utton>
    </div>
  );
};

export default ErrorFallback;
